const ApplicationSuccessful = () => {
  return (
    <div className="flex justify-center items-center text-center">
      <div className="w-full my-5 px-3 md:my-20">
        <div className="text-lg">
          <div className="text-xl lgg:text-4xl font-semibold text-portal-600 py-2 md:py-4 ">
            Application Submitted Successfully!
          </div>
          <div className="font-light text-md lgg:text-xl py-2">
            Thank you for completing your application. Our team is reviewing
            your information.
          </div>
          <div className="font-semibold pb-1 text-md lgg:text-xl py-2 md:py-4">
            You will receive an update within 24-48 hours.
          </div>
          <div className="font-light pb-1 text-md lgg:text-xl py-2 md:py-4">
            Once your account is ready, we’ll notify you by email or text with
            further instructions.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationSuccessful;
